import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import get from 'get-value';
import {
    BUTTON_LABEL_ASD_LOAD,
    BUTTON_LABEL_FREQUENT_QUESTION, FIELD_PRIORITY,
    FIELD_REFERENCE_NUMBER,
    FIELD_SEGMENT,
    FIELD_SUBJECT,
    TICKET_SECTION
} from '../../../../../../constants/formConstants';
import {InputFieldWithValidation} from '../../../../../common/fields/InputFieldWithValidation';
import {validReferenceNumberLength} from '../../../../../common/validationCommons';
import {domains, getPriority} from '../../../../../../constants/Utils';
import {PrimaryButton} from '../../../../../common/Button';
import {StyledDiv} from '../../../../../common/StyledComponents';
import FrequentQuestionModal from '../../../../../common/frequentQuestion/FrequentQuestionModal';
import InputSelectFieldWithValidation from '../../../../../common/fields/InputSelectFieldWithValidation';
import formValueSelector from 'redux-form/lib/formValueSelector';
import ValidFormattedMessage from '../../../../../common/ValidFormattedMessage';
import buttonMessages from '../../../../../../intl/common/buttonMessages';
import formMessages from '../../../../../../intl/modules/formMessages';
import Loader from '../../../../../Loader';
import {bindActionCreators} from 'redux';
import {
    asdDataResetActionCreator,
    asdDataSetActionCreator,
    fetchAsdInformationActionCreator
} from '../../../../../../actions/actionAsdData';
import {change} from 'redux-form';
import formTicketValuesMessages from '../../../../../../intl/common/formTicketValuesMessages';

const domain = domains.MARKETING;

class TicketSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpenFrequentQuestionModal: false,
        }
    }

    componentWillUnmount() {
        this.props.asdDataResetActionCreator();
    }

    handleAsdLoad = (e) => {
        const {referenceNumber, group, language} = this.props;
        e.preventDefault();
        this.props.fetchAsdInformationActionCreator(referenceNumber, group, language);
    };

    showModal = () => {
        this.setState({
            isOpenFrequentQuestionModal: true,
        });
    };

    closeModal = () =>
        this.setState({
            isOpenFrequentQuestionModal: false
        });

    fillRefNumberDetailFromAsd = () => {
        const {asdData, change} = this.props;
        change(`${TICKET_SECTION}.${FIELD_SEGMENT}`, get(asdData, 'asdData.segment', ''));
        this.props.asdDataSetActionCreator();
    };

    render() {
        const {readOnly, userRights, reqFields, subjects, subjectField, group, asdData} = this.props;
        const {isOpenFrequentQuestionModal} = this.state;
        const requiredField = subjects ? get(get(subjects, `marketingQuestion.${group}`, []).find(item => item.uuid === subjectField), 'refNoObligation', false) : false;

        if (asdData.asdSet) {
            this.fillRefNumberDetailFromAsd();
        }
        return (
            <>
                <h3 className="text-left ml-4">
                    <FormattedMessage {...formMessages.TICKET_SECTION}/>
                </h3>
                <StyledDiv className="border border-secondary bg-white px-4 py-2">
                    <div className="form-row">
                        <div className="col-12 pb-2">
                            <div className="form-row align-items-end">
                                <div className="col-md-12 col-lg-8 pb-2">
                                    <InputSelectFieldWithValidation
                                        label={formMessages.SUBJECT}
                                        field={FIELD_SUBJECT}
                                        customOptions={get(subjects, `marketingQuestion.${group}`, [])}
                                        isDisabled={!userRights.canEditSubject || readOnly}
                                        isRequired={reqFields.includes(FIELD_SUBJECT) && !readOnly}/>
                                </div>
                                {userRights.canOpenFrequentQuestion && !readOnly &&
                                <>
                                    <div className="pl-2 pb-2">
                                        <PrimaryButton type="button" className="btn btn-sm"
                                                       onClick={this.showModal}
                                                       disabled={asdData.asdLoaded}>
                                            <ValidFormattedMessage message={BUTTON_LABEL_FREQUENT_QUESTION}
                                                                   intlMessages={buttonMessages}/>
                                        </PrimaryButton>
                                    </div>
                                </>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-12 pb-2">
                            <div className="form-row align-items-end">
                                <div className="col-md-12 col-lg-6 col-xl-4">
                                    <InputFieldWithValidation
                                        label={formMessages.REFERENCE_NUMBER}
                                        field={FIELD_REFERENCE_NUMBER}
                                        maxLength={10}
                                        validations={[validReferenceNumberLength]}
                                        isDisabled={!userRights.canEditReferenceNumber || readOnly || asdData.asdLoaded}
                                        isRequired={requiredField && !readOnly}
                                        isSmall/>
                                </div>
                                {userRights.canEditAsd && !readOnly &&
                                <>
                                    <div className="pl-2 pt-1">
                                        <PrimaryButton type="button" className="btn btn-sm"
                                                       onClick={this.handleAsdLoad}
                                                       disabled={asdData.asdLoaded}>
                                            <ValidFormattedMessage message={BUTTON_LABEL_ASD_LOAD}
                                                                   intlMessages={buttonMessages}/>
                                        </PrimaryButton>
                                    </div>
                                    <div className="pl-2 py-auto">
                                        {asdData.isAsdLoading &&
                                        <Loader isSmall/>
                                        }
                                    </div>
                                </>
                                }
                                <div className="col-md-12 col-lg-12 col-xl-4 offset-xl-2">
                                    <InputSelectFieldWithValidation
                                        label={formMessages.PRIORITY}
                                        field={FIELD_PRIORITY}
                                        notSortedOptions={getPriority}
                                        intlMessages={formTicketValuesMessages}
                                        isDisabled={!userRights.canEditPriority || readOnly}
                                        isRequired={reqFields.includes(FIELD_PRIORITY) && !readOnly}
                                        noEmpty/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-md-12 col-lg-6 col-xl-4 pb-2">
                            <InputFieldWithValidation
                                label={formMessages.SEGMENT}
                                field={FIELD_SEGMENT}
                                isRequired={requiredField && !readOnly}
                                isDisabled
                                isSmall/>
                        </div>
                    </div>
                </StyledDiv>
                {isOpenFrequentQuestionModal &&
                <FrequentQuestionModal show={isOpenFrequentQuestionModal}
                                       domain={domain}
                                       closeModal={this.closeModal}
                                       group={group}/>
                }
            </>
        )
    }
}

const mapStateToProps = (state, props) => ({
    subjects: state.adminSubjectSettings.subjectSettings.subjects,
    subjectField: formValueSelector(props.form)(state, `${TICKET_SECTION}.${FIELD_SUBJECT}`),
    group: formValueSelector(props.form)(state, `${TICKET_SECTION}.group`),
    referenceNumber: formValueSelector(props.form)(state, `${TICKET_SECTION}.${FIELD_REFERENCE_NUMBER}`),
    asdData: state.asdData,
    language: state.intl.language
});

const mapDispatchToProps = (dispatch, props) => ({
    ...bindActionCreators(
        {
            asdDataSetActionCreator,
            fetchAsdInformationActionCreator,
            asdDataResetActionCreator
        },
        dispatch,
    ),
    change: (name, value) => dispatch(change(props.form, name, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TicketSection);
